import React from "react";
import figma from "../../Images/figma.svg";
import web from "../../Images/mern.png";
import psd from "../../Images/psd.svg";
import "./MyServices.css";

const MyServices = () => {
  return (
    <div className="container mt-5 pb-5 mb-2">
      <h1 className="text-center pt-2 blogs-section">What I Do?</h1>
      <div className="services">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-md-6 col-lg-4 col-sm-12">
            <div className="service">
              <div>
                <img src={web} alt="" />
              </div>
              <h4 className="pt-4 blog-title">MERN Stack Website</h4>
              <p className="paragrap">
                I am a MERN stack Web Developer. I use MongoDB for database,
                Express, Node Js for server side. You can see some of my
                projects in "PROJECTS" tab.
              </p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 col-sm-12">
            <div className="service">
              <div>
                <div>
                  <img src={figma} alt="" />
                </div>
                <h4 className="pt-4 blog-title">Figma To HTML</h4>
                <p className="paragrap">
                  I can covert any Figma design to a responsive webpage. I use
                  HTML, CSS, Bootstrap, Vanilla Js, React JS for it. You can see
                  some of my projects in "PROJECTS" tab.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 col-sm-12">
            <div className="service">
              <div>
                <div>
                  <img src={psd} alt="" />
                </div>
                <h4 className="pt-4 blog-title">PSD To HTML</h4>
                <p className="paragrap">
                  I can covert any PSD design to a responsive webpage. I use
                  HTML, CSS, Bootstrap, Vanilla Js, React JS for it. You can see
                  some of my projects in "PROJECTS" tab.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyServices;
